import { ElementRef, EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
const _c0 = ["backDrop"];
const _c1 = a0 => ({ "show": a0 });
const _c2 = (a0, a1) => ({ "left": a0, "top": a1 });
function FundChartSeriesMenuComponent_Conditional_11_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵlistener("click", function FundChartSeriesMenuComponent_Conditional_11_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateDate.emit("start_date")); });
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵtext(2, "Update Start Date");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "div", 3);
    i0.ɵɵlistener("click", function FundChartSeriesMenuComponent_Conditional_11_Template_div_click_3_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateDate.emit("end_date")); });
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵtext(5, "Update End Date");
    i0.ɵɵelementEnd()();
} }
const COMPONENT_FIXED_WIDTH = 155;
const COMPONENT_FIXED_HEIGHT = 70;
const PADDING = 5;
export class FundChartSeriesMenuComponent {
    constructor() {
        this.showDatesOptions = false;
        this.editAnnotationHandler = new EventEmitter();
        this.openEventSummary = new EventEmitter();
        this.updateDate = new EventEmitter();
        this.isOpen = false;
        this.left = '0px';
        this.top = '0px';
        this.seriesIndex = 0;
    }
    open(left, top, seriesIndex) {
        const { height, width } = this.backDrop.nativeElement.getBoundingClientRect();
        const maxWidth = width - COMPONENT_FIXED_WIDTH - PADDING;
        let maxHeight = height - COMPONENT_FIXED_HEIGHT - PADDING;
        if (this.showDatesOptions) {
            maxHeight -= COMPONENT_FIXED_HEIGHT;
        }
        this.left = maxWidth - left > 0 ? `${left}px` : `${maxWidth}px`;
        this.top = maxHeight - top > 0 ? `${top}px` : `${maxHeight}px`;
        this.seriesIndex = seriesIndex;
        this.isOpen = true;
    }
    close() {
        this.isOpen = false;
    }
}
FundChartSeriesMenuComponent.ɵfac = function FundChartSeriesMenuComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartSeriesMenuComponent)(); };
FundChartSeriesMenuComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundChartSeriesMenuComponent, selectors: [["ycn-fund-chart-series-menu"]], viewQuery: function FundChartSeriesMenuComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.backDrop = _t.first);
    } }, inputs: { showDatesOptions: "showDatesOptions" }, outputs: { editAnnotationHandler: "editAnnotationHandler", openEventSummary: "openEventSummary", updateDate: "updateDate" }, standalone: false, decls: 12, vars: 12, consts: [["backDrop", ""], [1, "chart-backdrop"], [1, "chart-series-menu", "dropdown-menu", 3, "ngClass", "ngStyle"], [1, "dropdown-item", 3, "click"], [1, "dropdown-item-text"], ["ycnIcon", "", 1, "ml-1", 3, "name"]], template: function FundChartSeriesMenuComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelement(0, "div", 1, 0);
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3);
        i0.ɵɵlistener("click", function FundChartSeriesMenuComponent_Template_div_click_3_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.editAnnotationHandler.emit(ctx.seriesIndex)); });
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtext(5, "Annotate ");
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(6, "svg", 5);
        i0.ɵɵelementEnd()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(7, "div", 3);
        i0.ɵɵlistener("click", function FundChartSeriesMenuComponent_Template_div_click_7_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.openEventSummary.emit()); });
        i0.ɵɵelementStart(8, "div", 4);
        i0.ɵɵtext(9, "Event Summary ");
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(10, "svg", 5);
        i0.ɵɵelementEnd()();
        i0.ɵɵconditionalCreate(11, FundChartSeriesMenuComponent_Conditional_11_Template, 6, 0);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵstyleProp("visibility", ctx.isOpen ? "visible" : "hidden");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1, ctx.isOpen))("ngStyle", i0.ɵɵpureFunction2(9, _c2, ctx.left, ctx.top));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("name", "icon-gear");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("name", "icon-sparkle");
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showDatesOptions ? 11 : -1);
    } }, dependencies: [i1.NgClass, i1.NgStyle, i2.IconDirective], encapsulation: 2 });
